import React from 'react';
import { Edit, usePermissions, useEditContext, SimpleForm, useLocaleState } from 'react-admin';
import { ensureStockTicketIds, normalizeEventType } from '../../utils/eventFormUtils';

import NoDeleteToolbar from '../../components/form/NoDeleteToolbar';
import { SeatedProductFormComponent } from '../../components/stocks/StocksFormComponents';
import { StandardProductsEditor } from '../../components/form/event-fields/ProductFormManager';
import { SourceLanguageBanner } from '../../components/form/SourceLanguageBanner';

/**
 * Stock row edit — products for one session / stock.
 * Kayit sonrasi event edit'e doner (oturumlar orada).
 * Create ile ayni StandardProductsEditor UI kullanilir.
 */
export const StockEdit = (props) => {
  const { permissions } = usePermissions();
  if (!permissions) return null;

  return (
    <Edit title="Edit Stock / Products" {...props} redirect={false}>
      <StockEditForm />
    </Edit>
  );
};

const StockEditForm = () => {
  const { record } = useEditContext();
  const [locale] = useLocaleState();
  if (!record) return null;

  const stockType = normalizeEventType(record.type);
  const useSeatedForm =
    stockType === 3 || Boolean(record.seatSelections) || Array.isArray(record.stock);

  const eventId = record.event;
  const eventEditPath = eventId ? `/events-v2/${encodeURIComponent(eventId)}` : '/events-v2';
  const sourceLang = record.sourceLanguage || locale || 'tr';

  return (
    <SimpleForm
      toolbar={<NoDeleteToolbar />}
      shouldUnregister={false}
      transform={(data) => ({
        ...data,
        stock: ensureStockTicketIds(data.stock),
      })}
      redirect={eventEditPath}
    >
      {eventId && (
        <p style={{ marginTop: 0 }}>
          <a href={`/#${eventEditPath}`}>← Event edit</a>
        </p>
      )}
      {!useSeatedForm ? (
        <React.Fragment>
          <SourceLanguageBanner isEdit record={{ sourceLanguage: sourceLang }} />
          <StandardProductsEditor basePath="stock" sourceLang={sourceLang} isEdit />
        </React.Fragment>
      ) : (
        <SeatedProductFormComponent stock={record} sourceLang={sourceLang} />
      )}
    </SimpleForm>
  );
};
